import api from '@/api/auth_config/auth.js'

export default{

    login(data){
        const promise = api().post('/login',data)
        return promise.then((response) => response.data)

    }
}